export function decodeVariable(variable) {
  if (variable.value === null) return "---";
  if (variable.type >= 16) return decodeArrayVariable(variable);
  // normal value, just return it
  return variable.value;
}

function decodeArrayVariable(variable) {
  if (isNaN(variable.arrayIndex) || variable.arrayIndex === null) return " - ";
  var index = Number(variable.arrayIndex);
  var items = variable.value.split(';');
  if (index < 0 || index >= items.length) return "!!!";
  var value = items[index].split(':')[1];
  return value;
}

